import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';
import { getBrandDomain } from '../../../../../common/utils/getBrandDomain';

export default function Ls() {
    const brandDomain = getBrandDomain();
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark ls</span>
                    <span className={Styles.CommandSummary}>List running apps</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Show all apps currently running in the background. Stale entries (dead processes) are
                        automatically pruned.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Default</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>--json</td>
                                    <td>false</td>
                                    <td>Output as JSON</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Examples</div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Table output</code>
                            <br />
                            <code>modelpark ls</code>
                        </div>
                        <div className={Styles.CodeBlock}>
                            <code># JSON output</code>
                            <br />
                            <code>modelpark ls --json</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`NAME     STATUS   PORT   MODE    PID     UPTIME   URL
myapp    online   8501   run     12345   2h30m    https://myapp.${brandDomain}
demo     online   8000   serve   12346   45m      https://demo.${brandDomain}`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
